import { ClientJS } from 'clientjs';
const client = new ClientJS()

export const getBrowserSession = () => {
    const fp = client.getCustomFingerprint(
        client.getBrowser(),                 //  Chrome
        client.getOS(),                           //  Windows
        client.getDeviceType(),           //  desktop
        client.getTimeZone(),
        client.getLanguage(),
        client.getAvailableResolution(),
        client.getColorDepth(),
    );
    const thisSession = {
        useAgent: client.getUserAgent(),
        fingerPrint: String(fp),
        os: client.getOS(),
        browser: `${client.getBrowser()} ${String(client.getBrowser()).toLowerCase().includes('webview') ? '(App)' : '(Browser)'}`,
        resolution: client.getAvailableResolution(),
        isMobile: client.isMobile(),
    }
    return thisSession;
}
